<div #facetFiltersPills class="facet-selected-container">
  <div
    id="facet-selected-filters"
    [ngClass]="[isViewMore ? 'show-more' : 'show-less']"
  >
    <div class="tags-div">
      <ng-container *ngFor="let tag of tags; let i = index">
        <div *ngIf="tag['label']" class="tags">
          <span>{{ tag["label"] }}</span>
          <span class="close" (click)="handleClose(tag)">x</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div
    class="view-more-container"
    [ngClass]="[showBtnViewMore ? 'show' : 'hide']"
  >
    <va-button
      btnType="text"
      size="small"
      (click)="toggleViewMore()"
      class="view-more-button"
    >
      <span *ngIf="isViewMore">
        <span> View Less </span>
        <va-icon size="small" [isFontAwesome]="true" [name]="faChevronUp" class="icon"></va-icon>
      </span>
      <span *ngIf="!isViewMore">
        <span>View All ({{ tags.length }})</span>
        <va-icon size="small" [isFontAwesome]="true" [name]="faChevronDown" class="icon"></va-icon>
      </span>
    </va-button>
  </div>
</div>
